module.exports = __webpack_public_path__ + "media/images/czech-republic-6d9eed92682c0d25945dc33a72566425.svg";